/**
 * Play/pause Shopify-hosted videos in slideshow-with-video when slide changes.
 * Uses an attemptId guard to prevent race conditions between retries.
 */
(function () {
  var READY_TIMEOUT = 10000;
  var roots = [];

  function ensurePlayable(video) {
    if (!video) return;
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  function getVisibleVideo(videos) {
    for (var i = 0; i < videos.length; i++) {
      var media = videos[i].closest('.slideshow-with-video__media');
      if (!media) continue;
      var style = window.getComputedStyle(media);
      if (style.display !== 'none' && style.visibility !== 'hidden') return videos[i];
    }
    return null;
  }

  function getActiveSlideInfo(root) {
    var slider = root.querySelector('.slideshow.banner.slider');
    if (!slider) return null;

    var slides = root.querySelectorAll('.slideshow__slide');
    if (!slides.length) return null;

    var page = 0;
    var slideEl = slides[0];
    var w = slideEl ? slideEl.offsetWidth : 1;
    if (w > 0) {
      page = Math.min(slides.length - 1, Math.max(0, Math.round(slider.scrollLeft / w)));
    }

    return { slides: slides, activeIndex: page };
  }

  function startPlayback(video, attemptId, root) {
    if (!video || root._swvAttempt !== attemptId) return;
    ensurePlayable(video);

    if (video.readyState >= 2) {
      if (root._swvAttempt !== attemptId) return;
      video.play().catch(function () {});
      return;
    }

    var done = false;
    var onReady = function () {
      if (done || root._swvAttempt !== attemptId) return;
      done = true;
      video.removeEventListener('canplay', onReady);
      video.removeEventListener('loadeddata', onReady);
      video.play().catch(function () {});
    };
    var giveUp = function () {
      if (done) return;
      done = true;
      video.removeEventListener('canplay', onReady);
      video.removeEventListener('loadeddata', onReady);
    };

    video.addEventListener('canplay', onReady);
    video.addEventListener('loadeddata', onReady);
    setTimeout(giveUp, READY_TIMEOUT);

    video.load();
  }

  function syncVideos(root) {
    var info = getActiveSlideInfo(root);
    if (!info) return;

    root._swvAttempt = (root._swvAttempt || 0) + 1;
    var attemptId = root._swvAttempt;

    info.slides.forEach(function (slide, i) {
      var videos = Array.from(slide.querySelectorAll('.slideshow-with-video__media video'));
      if (!videos.length) return;

      if (i !== info.activeIndex) {
        videos.forEach(function (v) { v.pause(); });
        return;
      }

      var autoplay = slide.getAttribute('data-video-autoplay') === 'true';
      if (!autoplay) {
        videos.forEach(function (v) { v.pause(); });
        return;
      }

      var target = getVisibleVideo(videos) || videos[0];

      videos.forEach(function (v) {
        if (v !== target) v.pause();
      });

      if (!target.paused && target.readyState >= 2) return;

      startPlayback(target, attemptId, root);
    });
  }

  function isInteractiveTarget(target) {
    return !!(
      target &&
      target.closest(
        '.banner__buttons a, .banner__buttons button, .slider-button, .slideshow__controls, .slideshow__control-wrapper'
      )
    );
  }

  function getSlideHref(slide) {
    if (!slide) return '';
    var href = slide.getAttribute('data-slide-href');
    if (href) return href;
    var linkEl = slide.querySelector('.slideshow__slide-link, .slideshow__media-link');
    return linkEl && linkEl.href ? linkEl.href : '';
  }

  function initSlideNavigation(root) {
    if (root.dataset.swvNavInit === 'true') return;
    root.dataset.swvNavInit = 'true';

    root.addEventListener(
      'click',
      function (e) {
        if (isInteractiveTarget(e.target)) return;

        var slide = e.target.closest('.slideshow__slide');
        if (!slide || !root.contains(slide)) return;

        var href = getSlideHref(slide);
        if (!href) return;

        window.location.assign(href);
      },
      false
    );
  }

  function init(root) {
    if (root.dataset.slideshowVideoInit === 'true') return;
    root.dataset.slideshowVideoInit = 'true';
    root._swvAttempt = 0;
    roots.push(root);

    initSlideNavigation(root);

    var slider = root.querySelector('.slideshow.banner.slider');
    if (!slider) return;

    var scheduleSync = function () {
      window.requestAnimationFrame(function () { syncVideos(root); });
    };

    root.addEventListener('slideChanged', function () { syncVideos(root); });
    slider.addEventListener('scroll', scheduleSync, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleSync).observe(slider);
    }

    root.querySelectorAll('.slideshow-with-video__media video').forEach(function (video) {
      video.addEventListener('loadeddata', function () {
        syncVideos(root);
      }, { once: true });
    });

    syncVideos(root);

    setTimeout(function () { syncVideos(root); }, 1000);
    setTimeout(function () { syncVideos(root); }, 4000);

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.contains(root)) {
        setTimeout(function () { syncVideos(root); }, 200);
      }
    });
  }

  function resyncAll() {
    roots.forEach(function (root) {
      setTimeout(function () { syncVideos(root); }, 200);
    });
  }

  function boot() {
    document.querySelectorAll('slideshow-component.slideshow-with-video').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('slideshow-component.slideshow-with-video').forEach(init);
  });

  document.body.addEventListener('modalClosed', resyncAll);
})();
